<div>
  <div class="ai-sweep-line"></div>
  @switch (uiMode) {
    @case (0) {
      <div>
        <app-loading [size]="'50px'" [style]="{'margin-top': '50px'}"></app-loading>
      </div>
    }
    @case (1) {
      <div>
        <div style="padding-top: 100px; text-align: center">
          <mat-icon style="font-size: 40px; width: 50px; height: 50px">speed</mat-icon>
          <h1 style="font-size: 2.2em">Studio dashboard</h1>
          <mat-label>studio version {{version}} |</mat-label>
          <mat-label>cloud version {{cloudVersion}}</mat-label>
        </div>
      </div>
    }
    @case (2) {
      <div>
        <div class="panel" style="padding-top: 100px">
          @if (studioType === EnumStudioType.LITE) {
            <div style="text-align: center">
              <div class="form-main">
                <mat-label class="header ">
                  <div style="text-align: center">
                    <button mat-raised-button class="downloadMainBut" (click)="download('studio_lite')" mat-button>
                      <fa-icon size='lg' class="web" [icon]="faEdit"></fa-icon>
                      <span style="font-size: 1.4em">Login to StudioLite</span>
                    </button>
                    <br/>
                    <br/>
                    <br/>
                    <div class="os-info-text" style="opacity: 0.7">
                      {{'general.liteLogin' | transloco}}
                    </div>
                  </div>
                </mat-label>
              </div>
            </div>
          }
          @if (studioType === EnumStudioType.PRO) {
            <div style="text-align: center">
              <p style="font-size: 1.2em">[ {{'general.proLogin4' | transloco}} ]</p>
              <p style="font-size: 1.2em">{{'general.proLogin5' | transloco}}...</p>
              <app-studio-download [proStudioOnly]="true"></app-studio-download>
            </div>
          }
        </div>
      </div>
    }
    @case (3) {
      <div>
        <!-- ─── Hero band ────────────────────────────────────────────
             First-screen "wow" surface. Personal greeting, AI prompt
             with quick chip actions, animated mesh-gradient backdrop,
             live KPI strip. Below it the existing recents + templates
             carousels render unchanged. -->
        <section class="homeHero" aria-label="welcome">
          <div class="homeHeroMesh" aria-hidden="true">
            <span class="homeHeroBlob homeHeroBlob1"></span>
            <span class="homeHeroBlob homeHeroBlob2"></span>
            <span class="homeHeroBlob homeHeroBlob3"></span>
          </div>

          <div class="homeHeroInner">
            <div class="homeHeroGreet">
              <span class="homeHeroGreetEyebrow">{{ greeting }}{{ userFirstName ? (' ' + userFirstName) : '' }}</span>
              <h1 class="homeHeroTitle">
                <span class="homeHeroTitleLine1">{{ 'ai.home_hero_title_line1' | transloco }}</span>
                <span class="homeHeroTitleLine2">{{ 'ai.home_hero_title_line2' | transloco }}</span>
              </h1>
            </div>

            <div class="homeHeroPromptWrap">
              <div class="homeHeroPrompt">
                <mat-icon class="homeHeroPromptIcon">search</mat-icon>
                <input
                    type="text"
                    class="homeHeroPromptInput"
                    [(ngModel)]="aiPrompt"
                    (ngModelChange)="onHeroFilterInput()"
                    (focus)="onHeroFilterFocus()"
                    (blur)="onHeroFilterBlur()"
                    (keydown.enter)="onHeroFilterEnterOrPick()"
                    (keydown.arrowDown)="onHeroFilterArrow(1, $event)"
                    (keydown.arrowUp)="onHeroFilterArrow(-1, $event)"
                    (keydown.escape)="onHeroFilterBlur()"
                    [placeholder]="'ai.home_hero_prompt_placeholder' | transloco"
                    autocomplete="off" />
                <button type="button" class="homeHeroPromptBtn" (click)="onHeroCreateSceneSubmit()">
                  <span>{{ 'ai.home_hero_prompt_cta' | transloco }}</span>
                  <mat-icon>arrow_forward</mat-icon>
                </button>
              </div>

              @if (isHeroDropdownVisible) {
                <div class="homeHeroDropdown" role="listbox" (mousedown)="$event.preventDefault()">
                  <div class="homeHeroDropdownHeader">
                    <mat-icon>style</mat-icon>
                    <span>{{ heroMatches.length }} {{ 'ai.home_hero_dropdown_results' | transloco }}</span>
                  </div>
                  @for (match of heroMatches; track match.id; let idx = $index) {
                    <button
                        type="button"
                        class="homeHeroDropdownItem"
                        [class.isHighlighted]="idx === heroMatchHighlight"
                        (mouseenter)="heroMatchHighlight = idx"
                        (click)="onHeroFilterPick(match)"
                        role="option">
                      <mat-icon class="homeHeroDropdownItemIcon">collections</mat-icon>
                      <span class="homeHeroDropdownItemName">{{ match.label }}</span>
                      @if (match.size) {
                        <span class="homeHeroDropdownItemMeta">{{ match.size }}</span>
                      }
                      <span class="homeHeroDropdownItemId">#{{ match.id }}</span>
                    </button>
                  }
                </div>
              }
            </div>

            <div class="homeHeroChips">
              <button type="button" class="homeHeroChip" (click)="onHeroChipBlankScene()">
                <mat-icon>add_box</mat-icon>
                <span>{{ 'ai.home_hero_chip_blank' | transloco }}</span>
              </button>
              <button type="button" class="homeHeroChip" (click)="onHeroChipBrowseTemplates()">
                <mat-icon>collections</mat-icon>
                <span>{{ 'ai.home_hero_chip_templates' | transloco }}</span>
              </button>
              <button type="button" class="homeHeroChip" (click)="onHeroChipPlayers()">
                <mat-icon>monitor</mat-icon>
                <span>{{ 'ai.home_hero_chip_players' | transloco }}</span>
              </button>
              <button type="button" class="homeHeroChip" (click)="onHeroChipResources()">
                <mat-icon>photo_library</mat-icon>
                <span>{{ 'ai.home_hero_chip_resources' | transloco }}</span>
              </button>
            </div>

            <div class="homeHeroKpis">
              <div class="homeHeroKpi">
                <span class="homeHeroKpiDot homeHeroKpiDotOnline"></span>
                <span class="homeHeroKpiVal">{{ stationsOnline }}</span>
                <span class="homeHeroKpiLbl">{{ 'ai.home_hero_kpi_online' | transloco }}</span>
              </div>
              <div class="homeHeroKpiSep"></div>
              <div class="homeHeroKpi">
                <span class="homeHeroKpiVal">{{ stationsTotal }}</span>
                <span class="homeHeroKpiLbl">{{ 'ai.home_hero_kpi_players' | transloco }}</span>
              </div>
              <div class="homeHeroKpiSep"></div>
              <div class="homeHeroKpi">
                <span class="homeHeroKpiVal">{{ scenesTotal }}</span>
                <span class="homeHeroKpiLbl">{{ 'ai.home_hero_kpi_scenes' | transloco }}</span>
              </div>
            </div>
          </div>
        </section>

        <!--<app-studio-ads></app-studio-ads>-->

        <!-- Section order is intentional and matches the user-pick flow:
             1) hero band above (AI prompt)
             2) recent scenes — users with content go straight back to
                what they were working on
             3) showcase — the main animated card
             4) onboarding — getting-started checklist
             5) industries — narrow templates by vertical
             6) templates — the full library

             Every section below the hero is wrapped in app-home-section
             which adds the pin + minimize chrome and persists the user's
             choice via homeSectionPrefs in localStorage. -->

        <!-- PERF: every section below the hero is deferred so its heavy
             init (10 live PIXI scene previews, two ~2300-entry template
             scans, carousels, timers, thumb prefetch) does NOT block the
             first paint. Recents sits highest, so it loads on idle (right
             after the hero paints); the rest load as they scroll into
             view. Placeholders reserve height to avoid layout shift. -->
        <app-home-section sectionId="recents"
                          icon="slow_motion_video"
                          [title]="'ai.home_sec_recents_title' | transloco">
            @defer (on idle) {
                <app-scene-recents></app-scene-recents>
            } @placeholder {<div class="homeDeferSkel homeDeferSkelRecents" aria-hidden="true"></div>}
        </app-home-section>

        <app-home-section sectionId="showcase"
                          icon="auto_awesome"
                          [title]="'ai.home_sec_showcase_title' | transloco">
            @defer (on viewport) {
                <app-home-showcase></app-home-showcase>
            } @placeholder {<div class="homeDeferSkel homeDeferSkelShowcase" aria-hidden="true"></div>}
        </app-home-section>

        <app-home-section sectionId="inspire"
                          icon="video_library"
                          [title]="'ai.home_sec_inspire_title' | transloco">
            @defer (on viewport) {
                <app-home-inspire></app-home-inspire>
            } @placeholder {<div class="homeDeferSkel homeDeferSkelInspire" aria-hidden="true"></div>}
        </app-home-section>

        @if (showOnboardingSection) {
            <app-home-section sectionId="onboarding"
                              icon="rocket_launch"
                              [title]="'ai.home_sec_onboarding_title' | transloco">
                @defer (on viewport) {
                    <app-home-onboarding></app-home-onboarding>
                } @placeholder {<div class="homeDeferSkel homeDeferSkelOnboarding" aria-hidden="true"></div>}
            </app-home-section>
        }

        <!-- Templates is the heaviest section (full category library), so
             app-home-templates keeps initial load light by auto-cycling
             through one category at a time (see its auto-navigate logic)
             rather than rendering every category up front. -->
        <app-home-section id="homeTemplatesSection"
                          sectionId="templates"
                          icon="collections"
                          [title]="'ai.home_sec_templates_title' | transloco">
            @defer (on viewport) {
                <app-home-templates></app-home-templates>
            } @placeholder {<div class="homeDeferSkel homeDeferSkelTemplates" aria-hidden="true"></div>}
        </app-home-section>
      </div>
    }
    @case (4) {
      <div>
        <iframe [src]="embedCustomHomePage | pipeSafe:'resourceUrl'" width="100%" height="1000px">
          Sorry your browser does not support inline frames. please use latest Chrome browser.
        </iframe>
      </div>
    }
  }
</div>






